import type { ActionSource } from '../schema';
import { createAssetFailed } from './createAssetOnServer.locstring.json';
import { createOutlookSpaceAsset } from '../service';
import type { NewOutlookSpaceAsset, OutlookSpaceAsset, ProjectId } from 'owa-timestream-types';
import loc from 'owa-localize';
import showRetryNotification from '../utils/showRetryNotification';

export default async function createAssetOnServer(
    projectId: ProjectId,
    asset: NewOutlookSpaceAsset,
    source: ActionSource
): Promise<OutlookSpaceAsset> {
    return new Promise((resolve, reject) => {
        createOutlookSpaceAsset(projectId, asset)
            .then(resolve)
            .catch(() => {
                showRetryNotification('createAsset', loc(createAssetFailed), retry => {
                    if (retry) {
                        createAssetOnServer(projectId, asset, source).then(resolve).catch(reject);
                    } else {
                        reject();
                    }
                });
            });
    });
}
